import CategoryDeleteDialog from "#competence/components/category/CategoryDeleteDialog"
import CategoryForm from "#competence/components/category/CategoryForm"
import { CategoryInfoDialog } from "#competence/components/category/CategoryInfo"
import CategoryTable from "#competence/components/category/CategoryTable"
import { ContextsCategoryProvider } from "#competence/contexts/ContextsCategory"
import { Box } from "@mui/material"
import { ChangeTitle } from "Components/menu/funciones"

export default function Category() {
	ChangeTitle("Categoría")

	return (
		<ContextsCategoryProvider>
			<Box>
				<CategoryTable />
				<CategoryInfoDialog />
				<CategoryForm />
				<CategoryDeleteDialog />
			</Box>
		</ContextsCategoryProvider>
	)
}
